import { useQuery } from "@tanstack/react-query";
import { fetchShopifyProducts, ShopifyProduct } from "@/lib/shopify";

export function useShopifyProducts(first: number = 50, query?: string) {
  return useQuery({
    queryKey: ['shopify-products', first, query],
    queryFn: () => fetchShopifyProducts(first, query),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

// Helper to format price
export function formatShopifyPrice(amount: string, currencyCode: string = 'GBP'): string {
  const price = parseFloat(amount);
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currencyCode,
  }).format(price);
}

// Helper to get the first image URL or fallback
export function getProductImageUrl(product: ShopifyProduct['node'], fallback: string = '/placeholder.svg'): string {
  return product.images?.edges?.[0]?.node?.url || fallback;
}

// Helper to get all image URLs
export function getProductImageUrls(product: ShopifyProduct['node']): string[] {
  return product.images?.edges?.map(edge => edge.node.url) || [];
}

// Helper to check if product is available
export function isProductAvailable(product: ShopifyProduct['node']): boolean {
  return product.variants?.edges?.some(edge => edge.node.availableForSale) ?? false;
}
